import { combineReducers } from "redux";
import currentEntity from "./entityDetails";
import entityNotes from "./entityNotes";
import { objectsOwners } from "./objectsStakeholders";
import objects from "./objects";
import driveFolder from "./docsGoogleDrive";

const leadgen = combineReducers({
  currentEntity,
  entityNotes,
  objectsOwners,
  objects,
  driveFolder,
});

export default leadgen;
